export const LOG_IN_SIGN_UP_MODAL = 'LOG_IN_SIGN_UP_MODAL'
export const USER_PROFILE_MODAL = 'USER_PROFILE_MODAL'
export const UPDATE_VERIFICATION_MODAL = 'UPDATE_VERIFICATION_MODAL'
export const INVITE_USER_MODAL = 'INVITE_USER_MODAL'
export const UNSAVED_WORK_MODAL = 'UNSAVED_WORK_MODAL'
export const COOKIE_MODAL = 'COOKIE_MODAL'
export const WELCOME_MODAL = 'WELCOME_MODAL'
export const USER_IDLE_TIMEOUT_MODAL = 'USER_IDLE_TIMEOUT_MODAL'
